import { AnyDocument, DocsRequestPayload } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postRequestApplicationDocs = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: DocsRequestPayload,
): Promise<NonPaginatedResponse<AnyDocument> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/docs/request`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        [InceptHeader.RelatedDefinitionName]: 'doc',
      },
    },
    { preventDefaultErrorToast: true },
  );
